export const KEY = {
  Enter: "Enter",
  Escape: "Escape",
  Space: "Space",
} as const;
